import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { UploadSources } from 'src/app/modules/private/file-manager/models';

@Component({
  selector: 'app-upload-files-modal',
  templateUrl: './upload-files.component.html',
  standalone: false,
})
export class UploadFilesModalComponent {
  readonly modal = inject(NzModalRef);
  readonly nzData = inject<{
    source_name: UploadSources;
    source_id: any;
    files?: any[];
  }>(NZ_MODAL_DATA);
  isProcessing = false;
  countFiles = 0;
}
